import { BaseService } from '../common/service/base.service';

export class BaseMediaService extends BaseService {
  constructor(apiVersion: string = 'v1') {
    super(process.env.REACT_APP_MEDIA_API_URL || '', apiVersion);
  }
}
